import { gql } from '@apollo/client';

export const GQL_GET_ACCOUNT = gql`
  query GET_ACCOUNT {
    account {
      id
      name
      email
      client {
        id
        name
      }
    }
  }
`;
